import { Avatar, Grid, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import logo from "../utils/images/ridePlus.png";
import AuthMethodConflictMessage, {
  isUserAlreadyExistsAuthConflict,
} from "../components/AuthMethodConflictMessage";
import useTenantBranding from "../hooks/useTenantBranding";

// Error Page Loader Component — used for OAuth/SSO redirects (consent + direct login); query params come from the server.
function ErrorPageLoader() {
  const { tenantLogo, hideDefaultBranding } = useTenantBranding();
  const searchParams = new URLSearchParams(window.location.search);
  const params = new Proxy(searchParams, {
    get: (sp, prop) => sp.get(prop),
  });

  const showAuthMethodConflict =
    isUserAlreadyExistsAuthConflict(params.error_description) &&
    Boolean(params.auth_method?.trim());

  return (
    <Grid
      container
      sx={{
        minHeight: "100vh",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Container component="main" maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: 1,
            p: 2,
          }}
        >
          {(tenantLogo || !hideDefaultBranding) && (
            <Avatar
              sx={{
                width: 200,
                height: 180,
                borderRadius: 0
              }}
              alt="logo"
              src={tenantLogo || logo}
            />
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {showAuthMethodConflict ? (
              <AuthMethodConflictMessage authMethod={params.auth_method} />
            ) : (
              <>
                <Box
                  sx={{
                    display: "flex",
                    mb: 1,
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      display: "inline",
                      fontSize: 30,
                      fontWeight: "bold",
                      color: "primary.remove",
                    }}
                  >
                    Error.
                  </Typography>
                  {params.error ? (
                    <Typography
                      sx={{
                        display: "inline",
                        fontSize: 30,
                        color: "#9f9b94",
                        ml: 1,
                      }}
                    >
                      {params.error}.
                    </Typography>
                  ) : null}
                </Box>
                <Typography
                  sx={{ display: "inline", fontSize: 30, color: "#9f9b94" }}
                >
                  That's all we know.
                </Typography>
              </>
            )}
          </Box>
        </Box>
      </Container>
    </Grid>
  );
}
export default ErrorPageLoader;